"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionMenu = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_prop_types_1 = require("../react-prop-types");
var classnames_1 = require("../util/classnames");
var popover_1 = require("../popover");
var overlay_1 = require("../overlay");
var button_1 = require("../button");
var overflow_1 = __importDefault(require("adp-react-icons/lib/adp/overflow"));
var vdl_prefix_1 = require("../util/vdl-prefix");
var widget_helpers_1 = require("../util/widget-helpers");
var ActionMenu = /** @class */function (_super) {
  __extends(ActionMenu, _super);
  function ActionMenu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      isOverlayShown: false
    };
    _this.handlePopoverClick = function () {
      _this.hide();
    };
    _this.handleOverlayToggle = function (isOverlayShown) {
      _this.setState({
        isOverlayShown: isOverlayShown
      });
    };
    _this.hide = function () {
      _this._overlayTrigger.hide();
    };
    return _this;
  }
  ActionMenu.prototype.render = function () {
    var _a;
    var _this = this;
    var container = this.props.container;
    var popoverID = widget_helpers_1.instanceId(this, '_popover');
    var menuPopover = react_1.default.createElement(popover_1.Popover, {
      id: popoverID,
      className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('action-menu'), this.props.className)
    }, react_1.default.createElement("div", {
      onClick: this.handlePopoverClick
    }, this.props.children));
    var buttonClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('action-menu__button')] = true, _a[vdl_prefix_1.vdlPrefix('action-menu__button--open')] = this.state.isOverlayShown, _a[vdl_prefix_1.vdlPrefix("action-menu__button--" + this.props.size)] = true, _a);
    return react_1.default.createElement(overlay_1.OverlayTrigger, {
      trigger: "click",
      placement: this.props.position || 'bottom',
      container: container,
      overlay: menuPopover,
      defaultOverlayShown: this.state.isOverlayShown,
      animation: false,
      onToggle: this.handleOverlayToggle,
      ref: function ref(c) {
        return _this._overlayTrigger = c;
      }
    }, react_1.default.createElement(button_1.Button, {
      buttonStyle: "link",
      disabled: this.props.disabled,
      className: classnames_1.classNames(buttonClasses, this.props.buttonClassName)
    }, this.props.icon));
  };
  ActionMenu.propTypes = {
    icon: prop_types_1.default.node,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    buttonClassName: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    position: prop_types_1.default.oneOf(['top', 'right', 'left', 'bottom']),
    size: prop_types_1.default.oneOf(['sm', 'md']),
    container: prop_types_1.default.oneOfType([react_prop_types_1.componentOrElement, prop_types_1.default.func])
  };
  ActionMenu.defaultProps = {
    icon: react_1.default.createElement(overflow_1.default, null),
    disabled: false,
    size: 'md'
  };
  return ActionMenu;
}(react_1.default.Component);
exports.ActionMenu = ActionMenu;